import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';

if (environment.production) {
    enableProdMode();
    if(window?.console){
        window.console.log = () => {};
        window.console.warn = () => {};
        window.console.info = () => {};
    } 
}


Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: environment.aws.identityPoolId,
    //   region: environment.aws.region,
      userPoolId: environment.aws.userPoolId,
      userPoolClientId: environment.aws.userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: environment.aws.oauth.domain,
          scopes: ['profile', 'email', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [environment.aws.oauth.redirectUrl],
          redirectSignOut: [environment.aws.oauth.redirectLogoutUrl],
          responseType: 'code',
        },
      },
    },
  },
  API: {
    REST: {
      portal: {
        endpoint: environment.aws.apiEndpoint,
      },
    },
  },
});

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));